import React from 'react';
import { useHistory } from 'react-router-dom';
import AutodeskViewer from 'components/AutodeskViewer';

const DocumentPreview: React.FC = () => {
  const history = useHistory();
  const queryParams = new URLSearchParams(history?.location.search);
  const fileId = queryParams.get('fileId') || '';

  return (
    <div
      id="document-preview"
      data-testid="document-preview"
      className="document-preview"
    >
      {fileId && <AutodeskViewer fileId={fileId} />}
    </div>
  );
};

export default React.memo(DocumentPreview);
